
import { Player } from '@/types/tournament';
import { assignPlayersToCourts } from '@/utils/tournamentLogic';
import { generateAmericanoPartnerships, assignAmericanoCourts } from './americanoLogic';
import { ExtendedTournamentState, AmericanoPlayer } from './types';
import { toast } from 'sonner';

export const createStartTournament = (
  setTournamentState: React.Dispatch<React.SetStateAction<ExtendedTournamentState>>,
  setShowLeaderboard: (show: boolean) => void,
  language: string,
  t: (key: string, params?: any) => string
) => {
  return (players: Player[], rounds: number, type: 'mexicano' | 'americano' | 'team_americano' = 'mexicano') => {
    console.log(`Starting ${type} tournament with ${players.length} players`);

    if (type === 'americano') {
      // Americano tournament logic
      const americanoPlayers: AmericanoPlayer[] = players.map(player => ({
        ...player,
        points: 0,
        gamesPlayed: 0,
        partnerships: [],
        roundScores: []
      }));

      const partnerships = generateAmericanoPartnerships(americanoPlayers, 1);
      const matches = assignAmericanoCourts(partnerships);
      
      console.log('Americano tournament started:', { players: americanoPlayers.length, matches: matches.length });

      setTournamentState({
        tournamentType: 'americano',
        americanoPlayers,
        americanoMatches: matches,
        americanoRoundResults: [],
        isActive: true,
        currentRound: 1,
        totalRounds: 999, // Set to a high number to allow unlimited rounds
        isRoundActive: true,
        isFinished: false,
        players: [],
        courts: [],
        results: [],
        roundCourts: [],
        roundAmericanoMatches: [{ matches, results: [] }]
      });

      setShowLeaderboard(false);
      toast.success(language === 'no' ? 'Americano turnering startet!' : 'Americano tournament started!');
      return;
    }

    if (type === 'team_americano') {
      // Team Americano tournament logic - similar to regular Americano but with team constraints
      const americanoPlayers: AmericanoPlayer[] = players.map(player => ({
        ...player,
        points: 0,
        gamesPlayed: 0,
        partnerships: [],
        roundScores: []
      }));

      const partnerships = generateAmericanoPartnerships(americanoPlayers, 1);
      const matches = assignAmericanoCourts(partnerships);
      
      console.log('Team Americano tournament started:', { players: americanoPlayers.length, matches: matches.length });

      setTournamentState({
        tournamentType: 'team_americano',
        americanoPlayers,
        americanoMatches: matches,
        americanoRoundResults: [],
        isActive: true,
        currentRound: 1,
        totalRounds: 999, // Set to a high number to allow unlimited rounds
        isRoundActive: true,
        isFinished: false,
        players: [],
        courts: [],
        results: [],
        roundCourts: [],
        roundAmericanoMatches: [{ matches, results: [] }]
      });

      setShowLeaderboard(false);
      toast.success(language === 'no' ? 'Team Americano turnering startet!' : 'Team Americano tournament started!');
      return;
    }

    // Mexicano tournament logic
    const playersWithRoundScores = players.map(player => ({
      ...player,
      roundScores: []
    }));

    const courts = assignPlayersToCourts(playersWithRoundScores);
    
    console.log('Mexicano tournament started:', { players: playersWithRoundScores.length, courts: courts.length });
    console.log('Setting Mexicano tournament state:', {
      players: playersWithRoundScores,
      courts,
      results: [],
      currentRound: 1,
      totalRounds: 999, // Set to a high number to allow unlimited rounds
      isActive: true,
      tournamentType: 'mexicano',
      americanoPlayers: [],
      americanoMatches: [],
      americanoRoundResults: [],
      isRoundActive: false,
      isFinished: false,
      roundCourts: [{ courts, results: [] }]
    });

    setTournamentState({
      players: playersWithRoundScores,
      courts,
      results: [],
      currentRound: 1,
      totalRounds: 999, // Set to a high number to allow unlimited rounds
      isActive: true,
      tournamentType: 'mexicano',
      americanoPlayers: [],
      americanoMatches: [],
      americanoRoundResults: [],
      isRoundActive: false,
      isFinished: false,
      roundCourts: [{ courts, results: [] }],
      roundAmericanoMatches: []
    });

    setShowLeaderboard(false);
    
    const message = language === 'no' 
      ? `Mexicano turnering startet med ${playersWithRoundScores.length} spillere!`
      : `Mexicano tournament started with ${playersWithRoundScores.length} players!`;
    
    toast.success(message);
  };
};
